import React from 'react'

const PerPageContext = React.createContext<number>(0)

export function PerPageProvider({children, perPage}: React.PropsWithChildren<{perPage: number}>) {
  return <PerPageContext.Provider value={perPage}>{children}</PerPageContext.Provider>
}

export function usePerPage() {
  return React.useContext(PerPageContext)
}

try{ PerPageContext.displayName ||= 'PerPageContext' } catch {}
try{ PerPageProvider.displayName ||= 'PerPageProvider' } catch {}